import React from 'react';
import { Button } from 'shards-react';
import { useTranslation } from 'react-i18next';
import { RootState, useDispatch, useSelector } from '../../../redux/store';
import { setDialogMode, openDialog, selectInformation } from '../../../redux/slices/information';

const AddInformation = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  /**
   * モーダルオープン
   */
  const handleAddInformation = (): void => {
    dispatch(selectInformation());
    dispatch(setDialogMode('CREATE'));
    dispatch(openDialog());
  };

  // VIEW
  // ================================================================================
  return (
    <Button className="mr-2" theme="white" onClick={handleAddInformation}>
      <i className="material-icons">add</i>
      {t('information.login.add')}
    </Button>
  );
};

export default AddInformation;
